/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from 'ngx-bootstrap/modal/modal-backdrop.component';
const styles_ModalBackdropComponent:any[] = ([] as any[]);
export const RenderType_ModalBackdropComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_ModalBackdropComponent,data:{}});
export function View_ModalBackdropComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,([] as any[]),(null as any),(null as any));
}
export function View_ModalBackdropComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'bs-modal-backdrop',
      [['class','modal-backdrop']],(null as any),(null as any),(null as any),View_ModalBackdropComponent_0,
      RenderType_ModalBackdropComponent)),i0.ɵdid(114688,(null as any),0,i1.ModalBackdropComponent,
      [i0.ElementRef,i0.Renderer],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ModalBackdropComponentNgFactory:i0.ComponentFactory<i1.ModalBackdropComponent> = i0.ɵccf('bs-modal-backdrop',
    i1.ModalBackdropComponent,View_ModalBackdropComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9saWIvamVua2lucy93b3Jrc3BhY2UvdmVueW91LXN0cmlwZS9ub2RlX21vZHVsZXMvbmd4LWJvb3RzdHJhcC9tb2RhbC9tb2RhbC1iYWNrZHJvcC5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL2xpYi9qZW5raW5zL3dvcmtzcGFjZS92ZW55b3Utc3RyaXBlL25vZGVfbW9kdWxlcy9uZ3gtYm9vdHN0cmFwL21vZGFsL21vZGFsLWJhY2tkcm9wLmNvbXBvbmVudC5kLnRzIiwibmc6Ly8vdmFyL2xpYi9qZW5raW5zL3dvcmtzcGFjZS92ZW55b3Utc3RyaXBlL25vZGVfbW9kdWxlcy9uZ3gtYm9vdHN0cmFwL21vZGFsL21vZGFsLWJhY2tkcm9wLmNvbXBvbmVudC5kLnRzLk1vZGFsQmFja2Ryb3BDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8YnMtbW9kYWwtYmFja2Ryb3A+PC9icy1tb2RhbC1iYWNrZHJvcD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO3VDQUFBLFVBQUE7TUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/venyou-stripe/src/$$_gendir/~/ngx-bootstrap/modal/modal-backdrop.component.ngfactory.ts